import React from "react";
import { useCallback, useEffect } from "react";
import { observer } from "mobx-react";
import { useStores as useRpmStores, PluginUpdateEmbed, Avatar, Card, Form, Space } from "@devowl-wp/real-product-manager-wp-client";
import { i18n, rmlOpts } from "../../util";
const ConfigLicensingConsumer = observer(_ref => {
  let {
    withinModal = false,
    onClose
  } = _ref;
  const {
    pluginUpdateStore: {
      pluginUpdates
    }
  } = useRpmStores();
  const {
    slug,
    others: {
      isPro,
      showLicenseFormImmediate
    },
    publicUrl
  } = rmlOpts;
  const pluginUpdate = pluginUpdates.get(slug);
  const handleLicenseUpdated = useCallback(() => {
    // When form is shown directly after first usage, return to dashboard
    rmlOpts.others.showLicenseFormImmediate = false;
    onClose?.();
  }, []);
  const handleLicenseSkip = useCallback(() => {
    rmlOpts.others.showLicenseFormImmediate = false;
    pluginUpdate.skip();
    onClose?.();
  }, [pluginUpdate]);

  // Automatically skip if form already interacted (e.g. browser back cache issue)
  useEffect(() => {
    if (showLicenseFormImmediate && pluginUpdate?.hasInteractedWithFormOnce) {
      handleLicenseSkip();
    }
  }, [pluginUpdate, showLicenseFormImmediate, handleLicenseSkip]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, showLicenseFormImmediate && /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 650,
      textAlign: "center",
      margin: "0 auto"
    }
  }, !withinModal && /*#__PURE__*/React.createElement(Avatar, {
    src: `${publicUrl}images/logos/real-media-library.svg`,
    shape: "square",
    size: 130,
    style: {
      backgroundColor: "white",
      padding: 25,
      borderRadius: 999,
      marginBottom: 10
    }
  }), !withinModal && !isPro && /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 15,
      margin: "0 auto 20px"
    }
  }, i18n("licenseFreeDescription"))), /*#__PURE__*/React.createElement(Card, {
    title: withinModal || !pluginUpdate ? undefined : isPro || pluginUpdate.isLicensed ? i18n("licenseActivation") : i18n("licenseGetFreeActivation"),
    bordered: !withinModal
  }, /*#__PURE__*/React.createElement(Space, {
    direction: "vertical",
    size: "large"
  }, withinModal && !isPro && /*#__PURE__*/React.createElement("p", {
    className: "description",
    style: {
      fontWeight: "bold"
    }
  }, i18n("licenseFreeDescription")), /*#__PURE__*/React.createElement(PluginUpdateEmbed, {
    formProps: {
      onSave: handleLicenseUpdated,
      // Skip remote errors and move to dashboard immediately
      onFailure: showLicenseFormImmediate && !isPro ? handleLicenseSkip : undefined,
      footer: /*#__PURE__*/React.createElement(Form.Item, {
        style: {
          margin: "25px 0 0",
          textAlign: showLicenseFormImmediate ? "center" : undefined
        }
      }, /*#__PURE__*/React.createElement("button", {
        type: "submit",
        className: "button button-primary"
      }, showLicenseFormImmediate ? isPro ? i18n("licenseActivationBtnPro") : i18n("licenseActivationBtnFree") : i18n("save")))
    },
    listProps: {
      onDeactivate: handleLicenseUpdated
    },
    slug: slug
  }))), pluginUpdate && showLicenseFormImmediate && /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: "center",
      marginBottom: 20,
      marginTop: withinModal ? 24 : 20
    }
  }, /*#__PURE__*/React.createElement("a", {
    className: "button-link",
    onClick: handleLicenseSkip
  }, isPro ? i18n("licenseActivationSkipPro") : i18n("licenseActivationSkipFree"))));
});
export { ConfigLicensingConsumer };